if (typeof Object.hasOwn !== "function") {
  Object.hasOwn = function (object: object, property: PropertyKey): boolean {
    if (object == null) {
      throw new TypeError("Cannot convert undefined or null to object");
    }
    return Object.prototype.hasOwnProperty.call(Object(object), property);
  };
}
